<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/h5jSwX/tc-custom/9781504013710.jpg?1707822774908" alt="This image is the cover for the book Silas Marner"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Silas Marner
      </h1>
      <p class="bookDescription body article font2">
        <b>A man becomes a recluse when he’s accused of a crime he did not commit</b><br/><br/> Silas Marner is a skilled weaver working long hours in London for a Calvinist sect that does not appreciate him. When the congregation’s funds are stolen, Silas is framed for the theft and excommunicated. Presumed guilty, abandoned by the love of his life, evicted from his modest home, and humiliated by the men he called his brothers, Silas wanders north to a small village in England’s bucolic countryside. Forsaking contact with humanity, he throws himself into his work, caring for little other than the constant movement of his hands and the stack of money he is slowly amassing. But fate sees it fit that Silas should lose his newfound wealth and gain the companionship of a young orphan, an experience that proves more valuable than any currency.<br/><br/> This ebook has been professionally proofread to ensure accuracy and readability on all devices.<br/><br/> “I think Silas Marner holds a higher place than any of the author’s works. It is more nearly a masterpiece; it has more of that simple, rounded, consummate aspect which marks a classical work.” —Henry James
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Eliot
      </h2>
      
      <p class="authorDescription body article">George Eliot (1819&ndash;1880) was the pseudonym of Mary Ann Evans, one of the defining authors of the Victorian era, who penned influential works such as <I>Adam Bede</I>, <I>Middlemarch</I>, <I>The Mill on the Floss</I>, and <I>Silas Marner</I>. Eliot began her career by writing for local newspapers, eventually running the <I>Westminster Review</I>. During her time there, she decided to become a novelist and chose a masculine pen name in order to avoid the rampant sexism of the day. Her first novel, <I>Adam Bede</I>, was an instant success. Eliot&rsquo;s realist philosophy and deep characterizations were defining features of her work, and her classic novels have earned her praise as one of the English language&rsquo;s top authors.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8ad6e2b4